export default {
      id: "common__signal_lost-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__signal_lost",
      toString: function () {
        return this.url;
      }
    }